import { render } from "./all-soal-benar-salah.vue?vue&type=template&id=8ff0ab5c&scoped=true"
import script from "./all-soal-benar-salah.vue?vue&type=script&lang=js"
export * from "./all-soal-benar-salah.vue?vue&type=script&lang=js"

import "./all-soal-benar-salah.vue?vue&type=style&index=0&id=8ff0ab5c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff0ab5c"]])

export default __exports__